<template lang="html">
  <div>
    <div
      class="automatic-recharge"
      v-if="isAdmin">
      <div class="card">
        <div class="card-header">
          <h3 class="text-nowrap">Recarga Automática</h3>
          <div class="w-100">
          <!-- <font
              class="float-right"
              title="Tutorial"
              size="6"
              color="black"
              @click.prevent="openTutorial">
              <i class="ik ik-youtube" />
            </font> -->
          </div>
        </div>
        <div class="card-body">
          <div
            v-if="error"
            class="alert alert-danger"
            role="alert">
            <span v-html="error.message" />
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-6 d-flex">
              <div class="input-group">
                <div class="input-group-prepend">
                  <button
                    disabled
                    class="input-group-text">por página</button>
                </div>
                <select
                  class="custom-select custom-select-sm form-control form-control-sm perPage"
                  id="perPage"
                  v-model="perPage">
                  <option
                    v-for="option in pageOptions"
                    :key="option"
                    :value="option">
                    {{ option }}
                  </option>
                </select>
              </div>
              <div class="ml-auto">
                <automatic-recharge-new v-if="allowCreateAutomaticRecharge && !hasActiveAutomaticRecharge" />
                <router-link
                  v-else-if="!allowCreateAutomaticRecharge && !hasActiveAutomaticRecharge"
                  class="btn btn-sm btn-primary"
                  :to="{ name: 'financialData', params: { returnTo: 'automaticRecharge' }}">
                  Para realizar recargas automáticas informe seus dados aqui
                </router-link>
              </div>
            </div>
            <div class="col-sm-12 col-md-6 d-flex">
              <div class="input-group filter ml-auto">
                <input
                  type="text"
                  class="form-control form-control-sm"
                  placeholder="Buscar por"
                  aria-label="Buscar por"
                  v-model="filter">
                <div class="input-group-append">
                  <button
                    :disabled="!filter"
                    @click="filter = ''"
                    class="input-group-text">Limpar</button>
                </div>
              </div>
            </div>
          </div>
          <div class="card-table text-left">
            <b-table
              class="table"
              show-empty
              striped
              hover
              small
              :items="items"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              :filter="filter"
              @filtered="onFiltered">
              <template
                slot="automaticRechargeActions"
                slot-scope="row">
                <div v-if="isAutomaticRechargeActive(row.item)">
                  <automatic-recharge-edit
                    :id="row.item.id"
                    :minimum-amount="row.item.minimumAmount"
                    :recharge-amount="row.item.rechargeAmount"
                  />
                  &nbsp;| <a
                    class="link"
                    href="#"
                    @click.prevent="cancelAutomaticRechargeModal(row.item.id)">
                    Cancelar
                  </a>
                </div>
                <div v-else-if="isAutomaticRechargePaused(row.item)">
                  <a
                    class="link"
                    href="#"
                    @click.prevent="cancelAutomaticRechargeModal(row.item.id)">
                    Cancelar
                  </a>
                  | <a
                    class="link"
                    href="#"
                    @click.prevent="unpauseAutomaticRechargeModal(row.item.id)">
                    Despausar
                  </a>
                </div>
              </template>
              <template
                slot="type"
                slot-scope="row">
                <span :title="row.item.description">{{ row.item.type }}</span>
              </template>
            </b-table>
          </div>
          <b-pagination
            align="center"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            :limit="10" />
        </div>
      </div>
      <div
        class="modal fade"
        tabindex="-1"
        role="dialog"
        id="cancelAutomaticRechargeModal"
        ref="cancelAutomaticRechargeModal"
        data-keyboard="false"
        data-backdrop="static"
        aria-hidden="true">
        <div
          class="modal-dialog modal-dialog-centered"
          role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <h4 class="modal-title">Você tem certeza que deseja cancelar esta recarga automática?</h4>
            </div>
            <div class="modal-footer">
              <div class="buttons">
                <button
                  type="button"
                  class="btn btn-outline-secondary"
                  data-dismiss="modal">Não</button>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click.prevent="cancelAutomaticRecharge">Sim</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="modal fade"
        tabindex="-1"
        role="dialog"
        id="unpauseAutomaticRechargeModal"
        ref="unpauseAutomaticRechargeModal"
        data-keyboard="false"
        data-backdrop="static"
        aria-hidden="true">
        <div
          class="modal-dialog modal-dialog-centered"
          role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <h4 class="modal-title">Você tem certeza que deseja despausar esta recarga automática?</h4>
            </div>
            <div class="modal-footer">
              <div class="buttons">
                <button
                  type="button"
                  class="btn btn-outline-secondary"
                  data-dismiss="modal">Não</button>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click.prevent="unpauseAutomaticRecharge">Sim</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="modal fade"
        tabindex="-1"
        role="dialog"
        id="automaticRechargeSuccess"
        ref="automaticRechargeSuccess"
        data-keyboard="false"
        data-backdrop="static"
        aria-hidden="true">
        <div
          class="modal-dialog modal-lg modal-dialog-centered"
          role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Recarga automática gerada com sucesso!</h5>
              <button
                type="button"
                class="close"
                @click.prevent="closeAutomaticRechargeSuccessModal">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body text-center">
              <h5>
                <span>Após a compensação, seus créditos serão adicionados automaticamente.</span><br>
                <span>Os pagamentos realizados com cartão de crédito têm a compensação quase sempre instantânea.</span><br>
                <span>Não salvamos os dados sensíveis do seu cartão de crédito.</span>
              </h5>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-outline-secondary"
                @click.prevent="closeAutomaticRechargeSuccessModal">OK</button>
            </div>
          </div>
        </div>
      </div>
      <div
        class="modal fade"
        tabindex="-1"
        role="dialog"
        id="tutorialAutomaticRecharge"
        ref="tutorialAutomaticRecharge"
        data-keyboard="false"
        data-backdrop="static"
        aria-hidden="true">
        <div
          class="modal-dialog modal-dialog-centered modal-lg"
          role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Tutorial Adicionar Recarga Automática</h4>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body text-center">
              <iframe
                width="760"
                height="420"
                src=""
                title="Tutorial Adicionar Recarga Automática"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" />
            </div>
            <div class="modal-footer" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loopback from '@/services/loopback'
import { EventBus } from '@/services/event-bus'
import AutomaticRechargeNew from '@/components/AutomaticRecharge/New.vue'
import AutomaticRechargeEdit from '@/components/AutomaticRecharge/Edit.vue'

export default {
  name: 'ChargeHistory',
  components: {
    AutomaticRechargeNew,
    AutomaticRechargeEdit
  },
  data () {
    return {
      error: null,
      financialData: null,
      deleteAutomaticRechargeId: null,
      unpauseAutomaticRechargeId: null,
      items: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50],
      filter: null,
      fields: {
        id: {
          label: '#',
          sortable: true
        },
        cardLastFourChar: {
          label: 'Cartão',
          sortable: false
        },
        minimumAmount: {
          label: 'Valor Mínimo',
          sortable: false,
          sortByFormatted: false,
          filterByFormatted: false,
          formatter: (value) => {
            return value ? `R$ ${this.parseAmount(value)}` : ''
          }
        },
        rechargeAmount: {
          label: 'Valor da Recarga',
          sortable: false,
          sortByFormatted: false,
          filterByFormatted: false,
          formatter: (value) => {
            return value ? `R$ ${this.parseAmount(value)}` : ''
          }
        },
        status: {
          label: 'Status',
          sortable: false
        },
        createdAt: {
          label: 'Criada em',
          sortable: true,
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (value) => {
            return this.parseDateTime(value)
          }
        },
        canceledAt: {
          label: 'Cancelada em',
          sortable: true,
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (value) => {
            return this.parseDateTime(value)
          }
        },
        automaticRechargeActions: {
          label: 'Ações',
          sortable: false
        }
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.getFinancialData()
      this.getAutomaticRecharge()
      EventBus.$on('reload-automatic-recharge', () => {
        this.getAutomaticRecharge()
      })
      EventBus.$on('automatic-recharge-success', () => {
        this.openAutomaticRechargeSuccessModal()
      })
    })
  },
  methods: {
    getAutomaticRecharge () {
      this.error = null
      const statusMap = {
        ACTIVE: 'Ativo',
        PAUSED: 'Pausado',
        UNACTIVE: 'Inativo'
      }
      loopback
        .get(`/automatic-recharges?page=1&filter[order]=createdAt%20DESC&filter[order]=id%20DESC`)
        .then(automaticRecharges => {
          this.items = automaticRecharges.data
            .map(f => {
              f.cardLastFourChar = f.cardBrand !== 'American Express'
                ? `XXXX-XXXX-XXXX-${f.cardLastFourChar}` : `XXXX-XXXXXX-X${f.cardLastFourChar}`
              f.minimumAmount = this.formatPrice(f.minimumAmount)
              f.rechargeAmount = this.formatPrice(f.rechargeAmount)
              f.status = statusMap[f.status]
              return f
            })
          this.totalRows = this.items.length
        })
        .catch((err) => {
          this.error = err
        })
    },
    unpauseAutomaticRechargeModal (id) {
      this.unpauseAutomaticRechargeId = id
      $(this.$refs.unpauseAutomaticRechargeModal).modal('show')
    },
    unpauseAutomaticRecharge () {
      loopback
        .put(`/automatic-recharges/${this.unpauseAutomaticRechargeId}/unpause`)
        .then(() => {
          this.unpauseAutomaticRechargeId = null
          $(this.$refs.unpauseAutomaticRechargeModal).modal('hide')
          this.getAutomaticRecharge()
        })
        .catch((err) => {
          this.err = err
          this.unpauseAutomaticRechargeId = null
          $(this.$refs.unpauseAutomaticRechargeId).modal('hide')
        })
    },
    cancelAutomaticRechargeModal (id) {
      this.deleteAutomaticRechargeId = id
      $(this.$refs.cancelAutomaticRechargeModal).modal('show')
    },
    cancelAutomaticRecharge () {
      loopback
        .post(`/automatic-recharges/${this.deleteAutomaticRechargeId}/cancel`)
        .then(() => {
          this.deleteAutomaticRechargeId = null
          $(this.$refs.cancelAutomaticRechargeModal).modal('hide')
          this.getAutomaticRecharge()
        })
        .catch((err) => {
          if (err && err.message === `automatic recharge id ${this.deleteAutomaticRechargeId} cannot be canceled`) {
            this.error = { message: `A recarga automática ID ${this.deleteAutomaticRechargeId} não pode ser cancelada` }
          } else {
            this.error = err
          }
          this.deleteAutomaticRechargeId = null
          $(this.$refs.cancelAutomaticRechargeModal).modal('hide')
        })
    },
    formatPrice (value) {
      let val = (value / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    openTutorial () {
      $(this.$refs.tutorialCharge).modal('show')
    },
    openAutomaticRechargeSuccessModal () {
      $(this.$refs.automaticRechargeSuccess).modal('show')
    },
    closeAutomaticRechargeSuccessModal () {
      $(this.$refs.automaticRechargeSuccess).modal('hide')
    },
    getFinancialData () {
      const financialData = this.$store.state.auth.financialData
      if (financialData) this.financialData = financialData
    },
    isAutomaticRechargeActive (charge) {
      return charge.status === 'Ativo'
    },
    isAutomaticRechargePaused (charge) {
      return charge.status === 'Pausado'
    },
    parseDate (date) {
      if (date) return new Date(date).toLocaleDateString('pt-BR', { timeZone: 'America/Sao_Paulo', hour12: false })
      return ''
    },
    parseDateTime (date) {
      if (date) return new Date(date).toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo', hour12: false })
      return ''
    },
    parseAmount (amount) {
      amount = amount.replace(/\./g, '').replace(',', '.')

      const amountParsed = parseFloat(amount)
      if (isNaN(amountParsed)) {
        return amount
      }
      return amountParsed.toFixed(2).replace('.', ',')
    }
  },
  computed: {
    isAdmin () {
      return this.$store.state.auth.user && this.$store.state.auth.user.role === 'ADMIN'
    },
    allowCreateAutomaticRecharge () {
      return this.financialData && this.financialData.status === 'ACTIVE'
    },
    hasActiveAutomaticRecharge () {
      return this.items && this.items.some(item => item.status === 'Ativo' || item.status === 'Pausado')
    }
  },
  watch: {
    editAutomaticRechargeAmount (newVal) {
      if (newVal >= 20 && newVal <= 50000) {
        this.error = null
      }
    },
    editAutomaticRechargeMinimumAmount (newVal) {
      if (newVal >= 5) {
        this.error = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.support-message-error {
  font-size: large;
}
.buttons {
  margin: auto;
  text-align: center;
}

.editAutomaticRechargeAmount, .editAutomaticRechargeMinimumAmount {
  max-width: 250px;
  margin: auto;
  text-align: center;
}

.editAutomaticRechargeAmount, .editAutomaticRechargeMinimumAmount {
  input {
    text-align: right;
    height: 35px;
    font-size: large;
  }
  .input-group-prepend label {
    height: 35px;
    font-size: large;
  }
  .input-group-append label {
    height: 35px;
    font-size: large;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AutomaticRecharge/History.vue